module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_the_model) ? _c('section', {
    staticClass: "huizhan-box"
  }, [_c('div', {
    staticClass: "huizhan-logo"
  }, [_c('h3', [_vm._v(_vm._s(_vm.huizhanName))]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.time) + "会展中心介绍")])]), _vm._v(" "), _c('div', {
    staticClass: "huizhan-content"
  }, [(_vm.imageItems.length > 0) ? _c('play-img', {
    attrs: {
      "images": _vm.imageItems,
      "size": _vm.imgStyle,
      "isLink": false
    }
  }) : _c('div', {
    staticClass: "huizhan-img-box"
  }, [_c('app-img', {
    attrs: {
      "src": _vm.poster.img_url,
      "css": _vm.imgStyle
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getHtml(_vm.content))
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-daa9252e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/HuizhanMode.vue
// module id = 187
// module chunks = 1